import { Component } from "../Component.js";
import { generateUid } from "../../utils/uid.js";

export class StatusOverlay extends Component {

    constructor(parent, options = {}) {

        if (!options.id)
            options.id = generateUid();

        super(parent, options);

        this.visible = 0;

    };

    getTitle() {

        return this.getI18n().t('component.status_overlay.title');

    };

    isVisible() {

        return this.visible > 0;

    };

    show() {

        this.visible++;
        this.invalidate();

    };

    hide() {

        this.visible--;
        if (this.visible < 0) {
            console.warn('Status overlay error: visible counter is negative!');
            this.visible = 0;
        }
        this.invalidate();

    };

    _render(r, vm) {

        const visible = this.visible;
        const id = this.getId();

        if (!visible)
            return r.div({ props: { id } });

        return r.div({ props: { id } }, [
            r.el('div', 'overlay blur active'),
            r.el('dialog', 'active', null, [
                r.heading(1, [
                    r.icon('spinner', 'fa-spin-pulse fa-1x'),
                    ' ',
                    this.getTitle(),
                ]),
            ]),
        ]);

    };

}